import { StateToken } from '@ngxs/store';
import { CurrentCatalogModel } from '@records/state/current-catalog/current-catalog.model';

export const CURRENT_CATALOG_STATE_TOKEN = new StateToken<CurrentCatalogModel>('currentCatalog');
